import { ENTRI_APP_ID } from '../constants'

export const getEntriConfig = (token, domain, certName, certValue, cfName, replaceWWW) => {
  const config = {
    applicationId: ENTRI_APP_ID,
    prefilledDomain: domain,
    token,
    dnsRecords: [
      {
        type: 'CNAME',
        host: certName.split('.')[0],
        value: certValue,
        ttl: 300
      },
      {
        type: 'CNAME',
        host: '*',
        value: cfName,
        ttl: 300
      }
    ],
    embeddedMode: {
      selector: '#entri-container'
    }
  }

  if (replaceWWW) {
    config.dnsRecords.push(
      {
        type: 'CNAME',
        host: 'www',
        value: cfName,
        ttl: 300
      },
      {
        type: 'A',
        host: '@',
        value: '18.168.91.127',
        ttl: 300
      }
    )
  }

  return config
}

export const checkEntriDomain = async ({ domain, token, cert, cfName, replaceWWW }, entri = window.entri) => {
  if (!entri || typeof entri.checkDomain !== 'function') {
    throw new Error('Entri is unavailable')
  }

  const config = getEntriConfig(token, domain, cert.name, cert.value, cfName, replaceWWW)
  const domainCheck = await entri.checkDomain(domain, config)
  const setupType = domainCheck?.setupType?.toLowerCase() === 'automatic' ? 'automatic' : 'manual'

  return { config, setupType }
}

export const getIncompleteDomainName = (record) => {
  const domain = record?.domain
  const subdomain = record?.subdomain

  if (!domain || !subdomain || domain === subdomain || domain.startsWith(`${subdomain}.`)) {
    return domain
  }

  if (subdomain.endsWith(`.${domain}`)) {
    return subdomain
  }

  return `${subdomain}.${domain}`
}

export const getIncompleteDomainPayload = (record, registrar = record?.registrar || record?.registrarName) => ({
  domain: getIncompleteDomainName(record),
  owner: true,
  replaceWWW: record?.isRootDomain ?? !record?.subdomain,
  registrar
})

const getIncompleteDomainFormAddress = (record, domainData) => {
  let domain = record?.domain || domainData.domain
  let subdomain = record?.subdomain ?? domainData.subdomain

  if (domain && subdomain && domain.startsWith(`${subdomain}.`)) {
    domain = domain.slice(subdomain.length + 1)
  } else if (domain && subdomain?.endsWith(`.${domain}`)) {
    subdomain = subdomain.slice(0, -(domain.length + 1))
  }

  return { domain, subdomain }
}

export const prepareIncompleteDomainSetup = async ({
  record,
  registrar,
  addDomain,
  formatRecords,
  entri = window.entri
}) => {
  const payload = getIncompleteDomainPayload(record, registrar)
  const response = await addDomain(payload)
  const domainData = response?.data

  if (
    !domainData?.domain ||
    !domainData?.token ||
    !domainData?.cert?.name ||
    !domainData?.cert?.value ||
    !domainData?.cfName
  ) {
    throw new Error('Incomplete custom domain response')
  }

  let setupType = 'manual'

  try {
    const result = await checkEntriDomain(
      {
        domain: domainData.domain,
        token: domainData.token,
        cert: domainData.cert,
        cfName: domainData.cfName,
        replaceWWW: payload.replaceWWW
      },
      entri
    )
    setupType = result.setupType
  } catch {
    // Manual DNS remains available when the Entri SDK or capability check fails.
  }

  const formAddress = getIncompleteDomainFormAddress(record, domainData)
  const freshRecords = domainData.records
    ? null
    : formatRecords?.(
        {
          Name: domainData.cert.name,
          Value: domainData.cert.value
        },
        domainData.cfName,
        payload.replaceWWW
      )

  const modalData = {
    ...record,
    ...domainData,
    ...formAddress,
    records: domainData.records || freshRecords || record?.records
  }

  return { domainData, modalData, payload, setupType }
}
